import { NativeDateAdapter } from "@angular/material";
declare var moment: any;

export class CustomDateAdapter extends NativeDateAdapter {

    format(date: Date, displayFormat: Object): string {
        if (displayFormat === 'input') {
            return moment(date).format('MMM DD, YYYY');
        } else {
            return moment(date).format(displayFormat);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/date-adapter.service.ts